import './styles.scss';

import { ForwardedRef, ReactElement, forwardRef } from 'react';

import { Button as BootstrapButton } from 'react-bootstrap';
import { ButtonTypes } from '@/common/Button/types';
import { getClasses } from '@/utils';

const Button = forwardRef<ButtonTypes.RefType, ButtonTypes.Props>(
  (props: ButtonTypes.Props, ref: ForwardedRef<ButtonTypes.RefType>): ReactElement => {
    return <BootstrapButton {...props} className={getClasses('Button', 'Common', props.className)} ref={ref} />;
  }
);
Button.displayName = 'Button';

export default Button;
